
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none","fill-rule":"evenodd","clip-rule":"evenodd"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 29.223V9.667A3.666 3.666 0 0110.667 6h22a3.666 3.666 0 013.666 3.667v19.556c0 1.33-.722 2.56-1.886 3.205l-11 6.11a3.664 3.664 0 01-3.562 0l-11-6.11A3.67 3.67 0 017 29.223z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M21.68 14.548a2.315 2.315 0 00-2.308 2.323 2.315 2.315 0 002.308 2.323 2.315 2.315 0 002.308-2.323 2.315 2.315 0 00-2.308-2.323zm-3.846 2.323c0-2.138 1.722-3.871 3.846-3.871s3.846 1.733 3.846 3.871-1.722 3.87-3.846 3.87-3.846-1.732-3.846-3.87zM20.162 23.839a2.85 2.85 0 00-2.841 2.86c0 .03.002.055.006.074l.001.007c.411.229 1.574.672 4.352.672 2.778 0 3.94-.444 4.352-.672v-.007a.407.407 0 00.007-.075 2.85 2.85 0 00-2.842-2.86h-3.035zm-4.38 2.86c0-2.435 1.961-4.409 4.38-4.409h3.035c2.42 0 4.38 1.974 4.38 4.409 0 .434-.146 1.05-.727 1.393-.706.418-2.164.908-5.17.908-3.007 0-4.464-.49-5.17-.908-.581-.344-.728-.96-.728-1.393z"}})])])
          )
        }
      }
    